/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum AppointmentCreationChooseAnotherDateAliases {
  BUTTON_CHOOSE_ANOTHER_DATE_CANCEL = 'button-choose-another-date-cancel',
  BUTTON_CHOOSE_ANOTHER_DATE_SAVE = 'button-choose-another-date-save',
  DATE_PICKER_APPOINTMENT_RANGE = 'date-picker-appointment-range',
  FIELD_AVAILABLE_PERIOD = 'field-available-period',
  FIELD_AVAILABLE_TIME = 'field-available-time',
  FORM_CHOOSE_ANOTHER_DATE = 'form-choose-another-date',
  GLOBAL_ACTIONS_CHOOSE_ANOTHER_DATE = 'global-actions-choose-another-date',
  LAYOUT_APPOINTMENT_CHOOSE_ANOTHER_DATE = 'layout-appointment-choose-another-date',
  PANEL_CHOOSE_ANOTHER_DATE = 'panel-choose-another-date',
  TIME_FIELD_AVAILABLE_TIME = 'time-field-available-time',
}
export { AppointmentCreationChooseAnotherDateAliases };
